<template>
  <div class="app-container">
    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column width="200" prop="fileName" :label="$t('billingPage.FileName')" align="center"></el-table-column>
      <el-table-column width="64" prop="carrier" :label="$t('billingPage.Carrie')" align="center"></el-table-column>
      <el-table-column width="150" prop="operatedDate" :label="$t('billingPage.OperatedDate')" align="center"></el-table-column>
      <el-table-column width="80" prop="createdBy" :label="$t('billingPage.Operator')" align="center"></el-table-column>
      <el-table-column width="94" prop="weekyear" :label="$t('billingPage.YearWeek')" align="center">
          <template slot-scope="props">
            <span>{{ props.row.year }} / {{ props.row.week }}</span>
          </template>
        </el-table-column>
      <el-table-column width="155" prop="surchargedItems" :label="$t('billingPage.SurchargedItems')" align="center"></el-table-column>
      <el-table-column width="150" prop="surchargedAmount" :label="$t('billingPage.SurchargedAmount')" align="center"></el-table-column>
      <el-table-column prop="detail" :label="$t('detailsText')" align="center"></el-table-column>
    </el-table>
  </div>
</template>
<script>
import { billApi } from '@/api';
export default {
  data() {
    return {
      tableData: [],
    };
  },
  mounted() {
    this.getPageDataList();
  },
  methods: {
    // 获取页面数据
    getPageDataList() {
      billApi.surchargedFileHistoryList().then(res => {
        this.tableData = res.data.content;
      });
    },
  },
};
</script>
